module.exports = __webpack_public_path__ + "img/email.976c131f.svg";